import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3","key":"svg-1"}]]

const IconNumber12Small = createReactComponent('outline', 'number-12-small', 'Number12Small', __iconNode);

export default IconNumber12Small;